import * as React from 'react'

import { connect } from 'react-redux'

import { ApplicationState, changePasswordRequest } from '../../redux'
import { PasswordChangeForm }                      from '../forms'

const mstp = (state: ApplicationState) =>
  ({ changePasswordCommunication: changePasswordRequest.communicationSelector(state) })

const actions = {
  changePassword: changePasswordRequest.actionCreator,
  resetChangePassword: changePasswordRequest.resetActionCreator,
}

type ChangePasswordProps =
  ReturnType<typeof mstp>
  & typeof actions

class Account extends React.Component<ChangePasswordProps> {
  public componentWillUnmount () {
    this.props.resetChangePassword()
  }

  public render () {
    const {
      changePasswordCommunication,
      changePassword,
    } = this.props

    return (
      <PasswordChangeForm
        onSubmit={changePassword}
        {...changePasswordCommunication}
      />
    )
  }
}

export default connect(
  mstp,
  actions,
)(Account)



// WEBPACK FOOTER //
// ./src/components/environments/Account.tsx